
import { Question } from "../../../utils/interface/exam";
import { SectionProps } from "./sectionInterface";
import DataRenderer from "../../render";
import QuestionData from "./common/questionData";

export default function McqQuestions(props: SectionProps) {

    const { question } = props;


    const optionStyle = (question: Question) => {

        const options = question.options || []

        if (options.length === 0) {
            return 'row'
        }

        const longestOption = options.reduce((prev, current) => {
            return (prev.text.length > current.text.length) ? prev : current
        })

        const text = longestOption.text;

        if (text.length < 40) {
            return 'row'
        } else {
            return 'column'
        }
    }



    return (
        <div className="question">
            {
                question.importance === 'very_important' ?
                    <span className="importance_badge very_imp">🔥 Very Important 🔥</span>
                    :
                    question.importance === 'important' &&
                    <span className="importance_badge very_imp">Important</span>
            }

            <h3 className="question_text">

                <span className="question_number">Q{question.question_number}.</span>
                <DataRenderer text={question.question_text} type='mathpix' />

            </h3>
            <QuestionData question={question} />

            <div className="question_options">
                <ol type={'A'} className="mcq-options" style={{ display: 'flex', flexDirection: optionStyle(question), justifyContent: 'space-between', width: '100%' }}>
                    {question.options && question.options.map((option, index) => (
                        <li style={{
                            marginRight: '10px',
                            display: 'flex',
                            flexDirection: 'row',
                            fontSize: 16, marginBottom: optionStyle(question) === 'column' ? 10 : 0
                        }} key={index}>
                            <span style={{ marginRight: 5 }}></span>
                            <DataRenderer text={option.text} type='mathpix' />
                        </li>))
                    }
                </ol>
            </div>
        </div>
    )
}